import Typography from '@mui/material/Typography';
import MuiToggleButtonGroup, {
  ToggleButtonProps as MuiToggleButtonProps,
} from '@mui/material/ToggleButton';
import { DEFAULT_BORDER_RADIUS } from 'src/theme/constants';

export type ToggleButtonProps = Pick<MuiToggleButtonProps, 'value' | 'sx'> & { children: string };

export const ToggleButton: React.FC<ToggleButtonProps> = ({ children, sx, ...props }) => {
  return (
    <MuiToggleButtonGroup
      {...props}
      sx={{
        textTransform: 'capitalize',
        px: 12,
        pt: 8,
        pb: 9,
        ...sx,
        '&.MuiToggleButton-root:first-child': {
          borderTopLeftRadius: DEFAULT_BORDER_RADIUS,
          borderBottomLeftRadius: DEFAULT_BORDER_RADIUS,
        },
        '&.MuiToggleButton-root:last-child': {
          borderTopRightRadius: DEFAULT_BORDER_RADIUS,
          borderBottomRightRadius: DEFAULT_BORDER_RADIUS,
        },
      }}
    >
      <Typography variant="text1" color="text.secondary">
        {children}
      </Typography>
    </MuiToggleButtonGroup>
  );
};
